module.exports = __webpack_public_path__ + "img/timbreTool-title.a0b27037.png";